import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { chain } from 'lodash';


@Pipe({ name: 'firstError' })
export class FirstErrorPipe implements PipeTransform {

  transform(control?: AbstractControl): string {
    return chain(control && control.errors)
      .keys()
      .sort()
      .first()
      .snakeCase()
      .toUpper()
      .value() || null;
  }
}
